/* eslint-disable max-len */
import React,{useState,useContext} from 'react'
import Modal from 'react-modal';
import HeaderContext from '../../Components/Context/HeaderContext';
import ThreeDotsLoader from '../../Components/LoadingDots';
import { distributorService } from '../../service/distributor.service';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width:'512px',
    },
};
function StatusHandleModal({selectedUser,OpenPopup,setOpenPopup,handleError,handleFetch}) {
    const {
        SetSuccessMessage,
        setcolorValue,
    } = useContext(HeaderContext);
    const [actvloader, setactvloader] = useState(false);
    const handleUpdate = async()=>{
        setactvloader(true);
        const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
        const newayload = {
            user_status:selectedUser.user_status==="0"?"1":"0",
        }
        const update = await distributorService.UpdateAssistantUsers(newayload,selectedUser.user_id,ACCOUNT_NUMBER);
        
        if (!update?.error && update.data.success_status) {
            SetSuccessMessage('Changes have been saved successfully!');
            setTimeout(() => {
                SetSuccessMessage('');
                setcolorValue(false);
                setactvloader(false);
                handleFetch();       
                setOpenPopup(false);
                setisPopup(false)

            }, 1000);
        } else {
            handleError(update.message.response.data.message)
        }
    }
    return (
        <Modal
            style={customStyles}
            isOpen={OpenPopup}
            ariaHideApp={false}
            onClick={() => {
                setOpenPopup('');
                setactvloader(false);
            }}
            onRequestClose={() => setOpenPopup('')}>
            <div className="modal-dialog modal-dialog-centered relative pointer-events-none">
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-center pr-4 border-gray-200 rounded-t-md">
                        <button type="button" data-bs-dismiss="modal" aria-label="Close" className="absolute top-6 right-6">
                            <img src="/images/close.svg" alt="icon" onClick={()=>{
                                setactvloader(false)
                                setOpenPopup(false);
                            }}/>
                        </button>
                    </div>
                    <h5 className="text-xl font-semibold leading-normal text-[#090406] text-center mt-[30px]" id="exampleModalScrollableLabel">
                        {selectedUser.user_status === '0' ? "Activate":"Deactivate"} Assistant User
                    </h5>
                    <div className="modal-body relative text-center pt-4 text-[#555259] font-normal sm:text-lg text-sm sm:px-0 px-1">
                        {selectedUser.first_name} {selectedUser.last_name} is currently {selectedUser.user_status === '0' ? "deactivated":"activated"}.<br />Are you sure you want to {selectedUser.user_status === '1' ? "deactivate":"activate"} this user?
                        {selectedUser.user_status === '0'&& <p className="text-sm font-normal text-[#555259] mt-2">Note: If you enable this user, the currently active user will be disabled.</p>}
                    </div>
                    <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-center p-6 border-gray-200 rounded-b-md">
                        <button 
                            onClick={()=>setOpenPopup(false)}
                            type="button" className="inline-block w-[100px] sm:py-2.5 py-1 bg-[#FFFFFF] border border-[#707070] text-[#555259] font-semibold text-xs9 rounded-lg transition duration-150 ease-in-out" data-bs-dismiss="modal" aria-label="Close">
                            Back
                        </button>
                        <button type="button" onClick={()=>handleUpdate()} className=" flex justify-center items-center inline-block w-[100px] sm:py-2.5 py-1 border border-[#707070] text-[#FFFFFF] bg-[#555259] font-semibold text-xs9 rounded-lg transition duration-150 ease-in-out ml-5 msg8" data-bs-dismiss="modal" aria-label="Close">
                            {actvloader ? <ThreeDotsLoader /> : 'Yes'} 
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default StatusHandleModal